function markdownToHtml(text) {
  if (!text) return ''

  let html = text
    // Remover emojis comunes (👋 👤 📋 💳 etc)
    .split('').filter(function(char) {
      var code = char.charCodeAt(0)
      // Remover caracteres fuera del rango ASCII básico y caracteres de control Unicode altos
      return code < 127 || (code >= 160 && code < 256)
    }).join('')
    // Bold: **text** -> <strong>text</strong>
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
    // Italic: *text* -> <em>text</em>
    .replace(/\*(.*?)\*/g, '<em>$1</em>')
    // Line breaks: \n -> <br/>
    .replace(/\n/g, '<br/>')

  return html
}

export default markdownToHtml
